<template>
  <el-popover
    placement="bottom-start"
    trigger="click"
  >
    <el-button
      slot="reference"
      class="border-0"
      circle
      plain
    >
      <FontAwesomeIcon
        :icon="['fas', 'ellipsis-v']"
        fixed-width
      />
    </el-button>

    <template v-if="actions.length > 0">
      <ul
        v-for="(group, groupIndex) in actions"
        :key="groupIndex"
        class="action-list"
      >
        <template v-for="(action, index) in group">
          <li
            v-if="action.visible || !action.hidden"
            :key="index"
            @click.native="action.event"
          >
            <span>{{ action.name }}</span>
          </li>
        </template>
      </ul>
    </template>

    <ul
      v-else
      class="action-list"
    >
      <li>
        <span>No Actions Available</span>
      </li>
    </ul>
  </el-popover>
</template>

<script>
export default {
  props: {
    actions: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "variables";

  .action-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-flow: column nowrap;

    li {
      height: 40px;
      display: flex;
      align-items: center;

      span {
        font-size: 0.8rem;
        padding-left: 8px;
      }

      &:hover {
        background-color: $lighter;
        cursor: pointer;
      }
    }
  }

  .hover-highlight {
    width: 15px;
    height: 15px;
    padding: 10px;

    &:hover {
      background-color: $lighter;
      border-radius: 50%;
      cursor: pointer;
    }
  }
</style>
